export const STATE_PROP = 'profile';

export const MEASUREMENT_FORMAT_STORAGE_KEY = 'measurementFormat';
export const MEASUREMENT_FORMAT = {
  METRIC: 'METRIC',
  IMPERIAL: 'IMPERIAL'
};
